module.exports = __webpack_public_path__ + "img/grayCup.4bd8c1a3.png";